import colors from "theme/config/colors";

export const BLOCKS = "blocks";
export const DROPDOWN = "dropdown";
export const WEIGHT_CODES = ["size", "size_g", "variant_value"];
export const COLOR_CODE = "color";
export const COLOR_VALUES = {
    Blå: colors.parametricColors.blue,
    Grön: colors.parametricColors.green,
    Röd: colors.parametricColors.red,
    Rosa: colors.parametricColors.pink,
    Svart: colors.parametricColors.black,
    Vit: colors.parametricColors.white,
};
